import { FilterInput } from '@kinetic-ui/data-layer';
import { UpdateConfig } from 'components/Table';
import { useRef, useState } from 'react';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { FilterConfig } from '../filterConfigs';

export const useCombinedTableControlsProps = ({
  search,
  combinedPreferenceKey,
  columnsPreferenceKey,
  filterConfigs,
}: {
  search?: boolean;
  /** when migrating, this should be the filter key*/
  combinedPreferenceKey?: keyof typeof PREFERENCE_KEYS;
  columnsPreferenceKey: keyof typeof PREFERENCE_KEYS;
  filterConfigs?: FilterConfig<any>[];
}) => {
  const [filterInputs, setFilterInputs] = useState<FilterInput[]>([]);
  const columnsRef = useRef<UpdateConfig[]>([]);
  const [searchText, setSearchText] = useState('');

  const definedFilterConfigs = !!filterConfigs && filterConfigs.length > 0;

  const combinedTableControlsProps = {
    filterConfigs,
    onFilterInputsChange: setFilterInputs,
    columnsRef: columnsRef,
    onSearchChange: search ? setSearchText : undefined,
    columnsPreferenceKey: PREFERENCE_KEYS[columnsPreferenceKey],
    filtersPreferenceKey: combinedPreferenceKey
      ? PREFERENCE_KEYS[combinedPreferenceKey]
      : undefined,
  };

  if (definedFilterConfigs) {
    combinedTableControlsProps.filterConfigs = filterConfigs;
  }

  return {
    state: {
      filterInputs,
      columnsRef: columnsRef,
      searchText,
    },
    combinedTableControlsProps,
  };
};
